export const registerServiceWorker = (): void => {
  if (!import.meta.env.PROD || !('serviceWorker' in navigator) || !window.isSecureContext) {
    return;
  }
  window.addEventListener(
    'load',
    () => {
      void navigator.serviceWorker.register('/service-worker.js', { scope: '/' });
    },
    { once: true },
  );
};
